import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { t as translate, tValue } from "@/lib/i18n";
import { PASSPORT_HI } from "@/lib/i18n_passport";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("lang") || "en");

  useEffect(() => {
    localStorage.setItem("lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const toggle = useCallback(() => setLang((l) => (l === "en" ? "hi" : "en")), []);
  const t = useCallback((key) => translate(lang, key), [lang]);
  const tv = useCallback((v) => tValue(lang, v), [lang]);

  const value = useMemo(() => ({ lang, setLang, toggle, t, tv }), [lang, toggle, t, tv]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);

// Per-page bilingual copy: pass { en: {...}, hi: {...} }, get the active language's object.
// Phrase translator: English UI phrase -> Hindi (falls back to data-value map, then English).
export const usePhrase = () => {
  const { lang, tv } = useContext(LanguageContext);
  return useCallback((x) => (lang === "hi" ? PASSPORT_HI[x] || tv(x) : x), [lang, tv]);
};

export const useCopy = (copy) => {
  const { lang } = useContext(LanguageContext);
  return copy[lang] || copy.en;
};
